import { useEffect, useState } from 'react';
import axios from '../utils/axiosConfig';
import { DEFAULT_JOURNAL_SETTINGS, JournalSettings } from '../config/journalDefaults';

/**
 * Fetches the public GET /api/journal/settings endpoint, falling back to
 * DEFAULT_JOURNAL_SETTINGS (neutral placeholders) while loading or if the
 * request fails, so pages never render blank/undefined branding fields.
 *
 * `settingsLoading` lets callers avoid rendering the neutral-placeholder
 * values (e.g. "Your Journal Name") as if they were real content -- show a
 * skeleton/neutral state instead while this is true.
 */
export function useJournalSettings(): JournalSettings & { settingsLoading: boolean } {
  const [settings, setSettings] = useState<JournalSettings>(DEFAULT_JOURNAL_SETTINGS);
  const [settingsLoading, setSettingsLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/journal/settings')
      .then((res) => setSettings({ ...DEFAULT_JOURNAL_SETTINGS, ...res.data }))
      .catch(() => {
        // Keep defaults if the request fails
      })
      .finally(() => setSettingsLoading(false));
  }, []);

  return { ...settings, settingsLoading };
}
